import { render, staticRenderFns } from "./ConfiguracaoGeral.vue?vue&type=template&id=aa9504d6&scoped=true&"
import script from "./ConfiguracaoGeral.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9504d6",
  null
  
)

export default component.exports